// src/config/ads.js

// Centralized advertisement configuration
// Each section has two ads (ad1, ad2) to show at different positions
// Ad types: 'image' or 'adsense'

export const advertisements = {
  bharat: {
    ad1: {
      id: "bharat_ad_2",
      type: "image",
      image:
        "https://ayg.s3.us-east-2.amazonaws.com/Red+And+White+Illustrated+Happy+Ram+Navami+Greeting+Instagram+Post.gif",
      link: "https://www.bharatabroad.com/ram-navami",
      title: "Demo",
      city: "salem",
      country: "india",
      state: "tamil nadu",
      zipcode: "638001",
    },
    ad2: {
      id: "bharat_ad_2",
      type: "image",
      image:
        "https://ayg.s3.us-east-2.amazonaws.com/WhatsApp+Image+2026-01-20+at+3.02.08+PM.jpeg",
      link: "https://dhanaminfosys.com/",
      title: "Demo",
      city: "salem",
      country: "india",
      state: "tamil nadu",
      zipcode: "638001",
    },
  },

  global: {
    ad1: {
      id: "global_ad_1",
      type: "image",
      image:
        "https://miro.medium.com/v2/resize:fit:600/1*HcMqTLZjpyEGzYNJ07NjTA.gif",
      link: "https://example.com/global-ad-1",
      title: "Advertisement 1",
      city: "",
      country: "global",
      state: "",
      zipcode: "",
    },
    ad2: {
      id: "global_ad_2",
      type: "image",
      image:
        "https://miro.medium.com/v2/resize:fit:600/1*HcMqTLZjpyEGzYNJ07NjTA.gif",
      link: "https://example.com/global-ad-2",
      title: "Advertisement 2",
      city: "",
      country: "global",
      state: "",
      zipcode: "",
    },
  },

  sports: {
    ad1: {
      id: "sports_ad_1",
      type: "image",
      image:
        "https://miro.medium.com/v2/resize:fit:600/1*HcMqTLZjpyEGzYNJ07NjTA.gif",
      link: "https://example.com/sports-ad-1",
      title: "Advertisement 1",
      city: "",
      country: "global",
      state: "",
      zipcode: "",
    },
    ad2: {
      id: "sports_ad_2",
      type: "image",
      image:
        "https://miro.medium.com/v2/resize:fit:600/1*HcMqTLZjpyEGzYNJ07NjTA.gif",
      link: "https://example.com/sports-ad-2",
      title: "Advertisement 2",
      city: "",
      country: "global",
      state: "",
      zipcode: "",
    },
  },

  finance: {
    ad1: {
      id: "finance_ad_1",
      type: "image",
      image:
        "https://miro.medium.com/v2/resize:fit:600/1*HcMqTLZjpyEGzYNJ07NjTA.gif",
      link: "https://example.com/finance-ad-1",
      title: "Advertisement 1",
      city: "",
      country: "global",
      state: "",
      zipcode: "",
    },
    ad2: {
      id: "finance_ad_2",
      type: "image",
      image:
        "https://miro.medium.com/v2/resize:fit:600/1*HcMqTLZjpyEGzYNJ07NjTA.gif",
      link: "https://example.com/finance-ad-2",
      title: "Advertisement 2",
      city: "",
      country: "global",
      state: "",
      zipcode: "",
    },
  },

  gossip: {
    ad1: {
      id: "gossip_ad_1",
      type: "image",
      image:
        "https://miro.medium.com/v2/resize:fit:600/1*HcMqTLZjpyEGzYNJ07NjTA.gif",
      link: "https://example.com/gossip-ad-1",
      title: "Advertisement 1",
      city: "",
      country: "global",
      state: "",
      zipcode: "",
    },
    ad2: {
      id: "gossip_ad_2",
      type: "image",
      image:
        "https://miro.medium.com/v2/resize:fit:600/1*HcMqTLZjpyEGzYNJ07NjTA.gif",
      link: "https://example.com/gossip-ad-2",
      title: "Advertisement 2",
      city: "",
      country: "global",
      state: "",
      zipcode: "",
    },
  },

  cricket: {
    ad1: {
      id: "cricket_ad_1",
      type: "image",
      image:
        "https://miro.medium.com/v2/resize:fit:600/1*HcMqTLZjpyEGzYNJ07NjTA.gif",
      link: "https://example.com/cricket-ad-1",
      title: "Advertisement 1",
      city: "",
      country: "india",
      state: "",
      zipcode: "",
    },
    ad2: {
      id: "cricket_ad_2",
      type: "image",
      image:
        "https://miro.medium.com/v2/resize:fit:600/1*HcMqTLZjpyEGzYNJ07NjTA.gif",
      link: "https://example.com/cricket-ad-2",
      title: "Advertisement 2",
      city: "",
      country: "india",
      state: "",
      zipcode: "",
    },
  },

  nfl: {
    ad1: {
      id: "nfl_ad_1",
      type: "image",
      image:
        "https://miro.medium.com/v2/resize:fit:600/1*HcMqTLZjpyEGzYNJ07NjTA.gif",
      link: "https://example.com/nfl-ad-1",
      title: "Advertisement 1",
      city: "",
      country: "usa",
      state: "",
      zipcode: "",
    },
    ad2: {
      id: "nfl_ad_2",
      type: "image",
      image:
        "https://miro.medium.com/v2/resize:fit:600/1*HcMqTLZjpyEGzYNJ07NjTA.gif",
      link: "https://example.com/nfl-ad-2",
      title: "Advertisement 2",
      city: "",
      country: "usa",
      state: "",
      zipcode: "",
    },
  },

  nba: {
    ad1: {
      id: "nba_ad_1",
      type: "image",
      image:
        "https://miro.medium.com/v2/resize:fit:600/1*HcMqTLZjpyEGzYNJ07NjTA.gif",
      link: "https://example.com/nba-ad-1",
      title: "Advertisement 1",
      city: "",
      country: "usa",
      state: "",
      zipcode: "",
    },
    ad2: {
      id: "nba_ad_2",
      type: "image",
      image:
        "https://miro.medium.com/v2/resize:fit:600/1*HcMqTLZjpyEGzYNJ07NjTA.gif",
      link: "https://example.com/nba-ad-2",
      title: "Advertisement 2",
      city: "",
      country: "usa",
      state: "",
      zipcode: "",
    },
  },

  soccer: {
    ad1: {
      id: "soccer_ad_1",
      type: "image",
      image:
        "https://miro.medium.com/v2/resize:fit:600/1*HcMqTLZjpyEGzYNJ07NjTA.gif",
      link: "https://example.com/soccer-ad-1",
      title: "Advertisement 1",
      city: "",
      country: "global",
      state: "",
      zipcode: "",
    },
    ad2: {
      id: "soccer_ad_2",
      type: "image",
      image:
        "https://miro.medium.com/v2/resize:fit:600/1*HcMqTLZjpyEGzYNJ07NjTA.gif",
      link: "https://example.com/soccer-ad-2",
      title: "Advertisement 2",
      city: "",
      country: "global",
      state: "",
      zipcode: "",
    },
  },

  golf: {
    ad1: {
      id: "golf_ad_1",
      type: "image",
      image:
        "https://miro.medium.com/v2/resize:fit:600/1*HcMqTLZjpyEGzYNJ07NjTA.gif",
      link: "https://example.com/golf-ad-1",
      title: "Advertisement 1",
      city: "",
      country: "global",
      state: "",
      zipcode: "",
    },
    ad2: {
      id: "golf_ad_2",
      type: "image",
      image:
        "https://miro.medium.com/v2/resize:fit:600/1*HcMqTLZjpyEGzYNJ07NjTA.gif",
      link: "https://example.com/golf-ad-2",
      title: "Advertisement 2",
      city: "",
      country: "global",
      state: "",
      zipcode: "",
    },
  },

  mlb: {
    ad1: {
      id: "mlb_ad_1",
      type: "image",
      image:
        "https://miro.medium.com/v2/resize:fit:600/1*HcMqTLZjpyEGzYNJ07NjTA.gif",
      link: "https://example.com/mlb-ad-1",
      title: "Advertisement 1",
      city: "",
      country: "usa",
      state: "",
      zipcode: "",
    },
    ad2: {
      id: "mlb_ad_2",
      type: "image",
      image:
        "https://miro.medium.com/v2/resize:fit:600/1*HcMqTLZjpyEGzYNJ07NjTA.gif",
      link: "https://example.com/mlb-ad-2",
      title: "Advertisement 2",
      city: "",
      country: "usa",
      state: "",
      zipcode: "",
    },
  },

  tennis: {
    ad1: {
      id: "tennis_ad_1",
      type: "image",
      image:
        "https://miro.medium.com/v2/resize:fit:600/1*HcMqTLZjpyEGzYNJ07NjTA.gif",
      link: "https://example.com/tennis-ad-1",
      title: "Advertisement 1",
      city: "",
      country: "global",
      state: "",
      zipcode: "",
    },
    ad2: {
      id: "tennis_ad_2",
      type: "image",
      image:
        "https://miro.medium.com/v2/resize:fit:600/1*HcMqTLZjpyEGzYNJ07NjTA.gif",
      link: "https://example.com/tennis-ad-2",
      title: "Advertisement 2",
      city: "",
      country: "global",
      state: "",
      zipcode: "",
    },
  },

  hockey: {
    ad1: {
      id: "hockey_ad_1",
      type: "image",
      image:
        "https://miro.medium.com/v2/resize:fit:600/1*HcMqTLZjpyEGzYNJ07NjTA.gif",
      link: "https://example.com/hockey-ad-1",
      title: "Advertisement 1",
      city: "",
      country: "canada",
      state: "",
      zipcode: "",
    },
    ad2: {
      id: "hockey_ad_2",
      type: "image",
      image:
        "https://miro.medium.com/v2/resize:fit:600/1*HcMqTLZjpyEGzYNJ07NjTA.gif",
      link: "https://example.com/hockey-ad-2",
      title: "Advertisement 2",
      city: "",
      country: "canada",
      state: "",
      zipcode: "",
    },
  },

  nhl: {
    ad1: {
      id: "nhl_ad_1",
      type: "image",
      image:
        "https://miro.medium.com/v2/resize:fit:600/1*HcMqTLZjpyEGzYNJ07NjTA.gif",
      link: "https://example.com/nhl-ad-1",
      title: "Advertisement 1",
      city: "",
      country: "usa",
      state: "",
      zipcode: "",
    },
    ad2: {
      id: "nhl_ad_2",
      type: "image",
      image:
        "https://miro.medium.com/v2/resize:fit:600/1*HcMqTLZjpyEGzYNJ07NjTA.gif",
      link: "https://example.com/nhl-ad-2",
      title: "Advertisement 2",
      city: "",
      country: "usa",
      state: "",
      zipcode: "",
    },
  },

  chess: {
    ad1: {
      id: "chess_ad_1",
      type: "image",
      image:
        "https://miro.medium.com/v2/resize:fit:600/1*HcMqTLZjpyEGzYNJ07NjTA.gif",
      link: "https://example.com/chess-ad-1",
      title: "Advertisement 1",
      city: "",
      country: "global",
      state: "",
      zipcode: "",
    },
    ad2: {
      id: "chess_ad_2",
      type: "image",
      image:
        "https://miro.medium.com/v2/resize:fit:600/1*HcMqTLZjpyEGzYNJ07NjTA.gif",
      link: "https://example.com/chess-ad-2",
      title: "Advertisement 2",
      city: "",
      country: "global",
      state: "",
      zipcode: "",
    },
  },

  auto: {
    ad1: {
      id: "auto_ad_1",
      type: "image",
      image:
        "https://miro.medium.com/v2/resize:fit:600/1*HcMqTLZjpyEGzYNJ07NjTA.gif",
      link: "https://example.com/auto-ad-1",
      title: "Advertisement 1",
      city: "",
      country: "global",
      state: "",
      zipcode: "",
    },
    ad2: {
      id: "auto_ad_2",
      type: "image",
      image:
        "https://miro.medium.com/v2/resize:fit:600/1*HcMqTLZjpyEGzYNJ07NjTA.gif",
      link: "https://example.com/auto-ad-2",
      title: "Advertisement 2",
      city: "",
      country: "global",
      state: "",
      zipcode: "",
    },
  },

  technology: {
    ad1: {
      id: "technology_ad_1",
      type: "image",
      image:
        "https://miro.medium.com/v2/resize:fit:600/1*HcMqTLZjpyEGzYNJ07NjTA.gif",
      link: "https://example.com/technology-ad-1",
      title: "Advertisement 1",
      city: "",
      country: "global",
      state: "",
      zipcode: "",
    },
    ad2: {
      id: "technology_ad_2",
      type: "image",
      image:
        "https://miro.medium.com/v2/resize:fit:600/1*HcMqTLZjpyEGzYNJ07NjTA.gif",
      link: "https://example.com/technology-ad-2",
      title: "Advertisement 2",
      city: "",
      country: "global",
      state: "",
      zipcode: "",
    },
  },

  entertainment: {
    ad1: {
      id: "entertainment_ad_1",
      type: "image",
      image:
        "https://miro.medium.com/v2/resize:fit:600/1*HcMqTLZjpyEGzYNJ07NjTA.gif",
      link: "https://example.com/entertainment-ad-1",
      title: "Advertisement 1",
      city: "",
      country: "global",
      state: "",
      zipcode: "",
    },
    ad2: {
      id: "entertainment_ad_2",
      type: "image",
      image:
        "https://miro.medium.com/v2/resize:fit:600/1*HcMqTLZjpyEGzYNJ07NjTA.gif",
      link: "https://example.com/entertainment-ad-2",
      title: "Advertisement 2",
      city: "",
      country: "global",
      state: "",
      zipcode: "",
    },
  },

  immigration: {
    ad1: {
      id: "immigration_ad_1",
      type: "image",
      image:
        "https://miro.medium.com/v2/resize:fit:600/1*HcMqTLZjpyEGzYNJ07NjTA.gif",
      link: "https://example.com/immigration-ad-1",
      title: "Advertisement 1",
      city: "",
      country: "global",
      state: "",
      zipcode: "",
    },
    ad2: {
      id: "immigration_ad_2",
      type: "image",
      image:
        "https://miro.medium.com/v2/resize:fit:600/1*HcMqTLZjpyEGzYNJ07NjTA.gif",
      link: "https://example.com/immigration-ad-2",
      title: "Advertisement 2",
      city: "",
      country: "global",
      state: "",
      zipcode: "",
    },
    ad3: {
      id: "immigration_ad_3",
      type: "image",
      image:
        "https://miro.medium.com/v2/resize:fit:600/1*HcMqTLZjpyEGzYNJ07NjTA.gif",
      link: "https://example.com/immigration-ad-3",
      title: "Advertisement 3",
      city: "",
      country: "global",
      state: "",
      zipcode: "",
    },
  },

  health: {
    ad1: {
      id: "health_ad_1",
      type: "image",
      image:
        "https://miro.medium.com/v2/resize:fit:600/1*HcMqTLZjpyEGzYNJ07NjTA.gif",
      link: "https://example.com/health-ad-1",
      title: "Advertisement 1",
      city: "",
      country: "global",
      state: "",
      zipcode: "",
    },
    ad2: {
      id: "health_ad_2",
      type: "image",
      image:
        "https://miro.medium.com/v2/resize:fit:600/1*HcMqTLZjpyEGzYNJ07NjTA.gif",
      link: "https://example.com/health-ad-2",
      title: "Advertisement 2",
      city: "",
      country: "global",
      state: "",
      zipcode: "",
    },
  },
};

// Helper function to get ads for a section (returns both ad1 and ad2)
export const getAdsForSection = (sectionName) => {
  const key = sectionName.toLowerCase();
  return advertisements[key] || { ad1: null, ad2: null };
};

// Helper function to filter ads by user location
export const getLocationFilteredAds = (sectionName, userLocation) => {
  const ads = getAdsForSection(sectionName);

  const filterAdByLocation = (ad) => {
    if (!ad) return null;

    // If ad is global, show to everyone
    if (ad.country === "global") return ad;

    // Match country (case insensitive)
    if (ad.country.toLowerCase() === userLocation.country?.toLowerCase()) {
      // If state is specified, check state match
      if (ad.state && userLocation.state) {
        return ad.state.toLowerCase() === userLocation.state.toLowerCase()
          ? ad
          : null;
      }
      // If city is specified, check city match
      if (ad.city && userLocation.city) {
        return ad.city.toLowerCase() === userLocation.city.toLowerCase()
          ? ad
          : null;
      }
      // Country match is enough if no specific state/city required
      return ad;
    }

    return null;
  };

  return {
    ad1: filterAdByLocation(ads.ad1),
    ad2: filterAdByLocation(ads.ad2),
    ad3: ads.ad3 ? filterAdByLocation(ads.ad3) : null,
  };
};
